import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';

import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import {
  getSelectedProcess,
  getSelectedProcessStatus,
  getSelectedAlias,
} from '../store/slices/domainOrchestratorPricingCommittee.slice';
import { useGetOrchestratorsQuery } from '../store/services/getOrchestrators';

export const useFilteredOrchestratorsCount = (status: string) => {
  const country = useSelector(getCountry);
  const selectedProcess = useSelector(getSelectedProcess);
  const selectedProcessStatus = useSelector(getSelectedProcessStatus);
  const workflowAlias = useSelector(getSelectedAlias);

  const queryArg = country
    ? { country, status, workflow_alias: workflowAlias || undefined }
    : skipToken;
  const { data } = useGetOrchestratorsQuery(queryArg as any);

  const count = useMemo(() => {
    if (!data) return 0;

    return data.filter(o => {
      const stepByName = selectedProcess
        ? o.workflow_steps.find(ws => ws.name === selectedProcess)
        : undefined;

      if (selectedProcess && selectedProcessStatus) {
        return stepByName?.status === selectedProcessStatus;
      }

      if (selectedProcess) {
        return !!stepByName;
      }

      if (selectedProcessStatus) {
        return o.workflow_steps.some(ws => ws.status === selectedProcessStatus);
      }

      return true;
    }).length;
  }, [data, selectedProcess, selectedProcessStatus]);

  return { count };
};
